var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-nav"},_vm._l((_vm.list),function(item,index){return _c('router-link',{key:item.name,staticClass:"page-nav-row",class:{ active: index === _vm.active },attrs:{"to":item.path}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }